<div *ngIf="!!messageData" [ngClass]="{'ivm-container-block': messageData?.type === 'error'}">
    <div id="ivmessage">
        <div class="ivm-container">
            <div class="ivm-inner ivm-type-{{ messageData?.type }}">
                <div *ngIf="messageData?.type === 'error'">
                    <mat-icon class="cancelIcon" (click)="onClose()">close</mat-icon>
                </div>
                <div *ngIf="messageData?.title" class="ivm-title">{{ messageData?.title }}</div>
                <div *ngIf="messageData?.code && messageData?.type === 'error'" class="ivm-text">{{ messageData?.code }}
                </div>
                <div *ngIf="messageData?.message" class="ivm-text">{{ messageData?.message }}</div>
                <div *ngIf="messageData?.traceid && messageData?.type === 'error'" class="ivm-text">
                    TraceID: {{messageData?.traceid }}</div>
            </div>
        </div>
    </div>
</div>